import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({ open, title, message, confirmLabel = "Confirmer", danger, onConfirm, onCancel, testid }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/70 backdrop-blur-sm" onClick={onCancel}>
      <div data-testid={testid} className="w-full max-w-md mx-4 bg-[#141414] border border-white/15 rounded-sm p-5" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start gap-3">
          <div className={`w-9 h-9 rounded-sm flex items-center justify-center shrink-0 ${danger ? "bg-[#EF4444]/15 text-[#EF4444]" : "bg-[#3B82F6]/15 text-[#3B82F6]"}`}>
            <AlertTriangle size={18} />
          </div>
          <div className="flex-1">
            <h3 className="font-chivo text-lg font-bold tracking-tight uppercase">{title}</h3>
            <p className="font-mono text-xs text-[#A3A3A3] mt-1.5 leading-relaxed">{message}</p>
          </div>
        </div>
        <div className="flex gap-2 mt-5 justify-end">
          <button data-testid="confirm-cancel" onClick={onCancel}
            className="font-mono text-xs uppercase tracking-wider border border-white/15 hover:bg-white/10 rounded-sm px-4 py-2 transition-colors">
            Annuler
          </button>
          <button data-testid="confirm-ok" onClick={onConfirm}
            className={`font-mono text-xs uppercase tracking-wider rounded-sm px-4 py-2 transition-colors text-white ${danger ? "bg-[#EF4444] hover:bg-[#DC2626]" : "bg-[#3B82F6] hover:bg-[#2563EB]"}`}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
